import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
  },
  addEventBtn: {
    color: theme.palette.success.main,
  },
  devBanner: {
    background: theme.palette.error.dark,
    marginBottom: theme.spacing(4),
  },
  prodBanner: {
    background: theme.palette.success.dark,
  },
  status: {
    padding: theme.spacing(1.5),
    margin: theme.spacing(2),
    maxWidth: '20%'
  },
  btn: {
    marginLeft: theme.spacing(2),
    color: 'whitesmoke'
  },
  btnEdit: {
    background: theme.palette.success.main,
  },
  btnDelete: {
    background: theme.palette.error.main
  },
  btnCancel: {
    background: theme.palette.warning.contrastText
  }
}))